function getIndexAttribute(vertexCount) {
    if (vertexCount < 255) return THREE.Uint8BufferAttribute;
    if (vertexCount < 65535) return THREE.Uint16BufferAttribute;
    else return THREE.Uint32BufferAttribute;
}

export default getIndexAttribute;
export { getIndexAttribute };